;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/album/:slug\",\"regex\":\"^/album/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/artist/:slug\",\"regex\":\"^/artist/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/login\"},{\"path\":\"/signup\"},{\"path\":\"/signup/confirm-email\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.1";import * as Sentry from "@sentry/nextjs";
import { createBrowserSentryOptions } from "@/monitoring/sentry/createBrowserSentryOptions";
import { isClientObservabilityEnabled } from "@/monitoring/sentry/isClientObservabilityEnabled";

if (isClientObservabilityEnabled()) {
  Sentry.init(createBrowserSentryOptions());
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
